
import WithModel from '@/mixins/withModel';
import { mixins, Options } from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import * as OM from '@/model';
import { VillageTripClient } from '@/services/Services';
import store from '@/store';
import Swiper from 'swiper';

@Options({})
export default class escursioniMap extends mixins(WithModel) {

    @Prop() villageIdentifier: string;

    userPosition: OM.LatLong = { lat: 0, long: 0 };
    center: OM.LatLong = { lat: 0, long: 0 };
    markers: OM.VillageTrip[] = [];
    posWatcher = null;
    showMap = false;
    mapContainer: HTMLDivElement = null;

    swiperEl: Swiper = null;

    mounted(){
        VillageTripClient.getByVillage(this.villageIdentifier)
        .then(x => {
            this.center = store.state.villageConfig.position;
            this.markers = x;

            this.posWatcher = navigator.geolocation.watchPosition(
            (val) => {
                this.userPosition.lat = val.coords.latitude;
                this.userPosition.long = val.coords.longitude;
            }, 
            (err) => {
                console.log("error in position")
                console.log(err)
            })

            this.showMap = true;
        })
        
        this.mapContainer = this.$refs.mapContainer as HTMLDivElement;
        let parent = this.mapContainer.parentElement;
        let parentHeight = parent.getBoundingClientRect().height;
        let availableHeight = window.innerHeight - parentHeight - 34; // -34 aggiunto per il titolo in margin-top negativo
        this.mapContainer.style.height = availableHeight + "px"; 

        this.swiperEl = this.$refs.tripsSwiperContainer as Swiper;

    }

    onSlideChange(event){
        let villageTrip = this.markers[event.detail[0].activeIndex];
        this.center = villageTrip.position;
    }

    beforeUnmount(){
        navigator.geolocation.clearWatch(this.posWatcher);
    }

    onMarkerClick(val){
        let index = this.markers.findIndex(x => val == x);
        (<any>this.swiperEl).swiper.slideTo(index);
    }

}
